import { useEffect } from "react";
import PropertyInput from "../components/inputs/input-property.tsx";
import {H, ViewCopy, ViewDialog} from "../components/view.tsx";
import { useStore } from "../state/state.ts";

export default function ViewBase2() {
  return (<ViewDialog ><ViewBase2Inner /></ViewDialog>)
}

export function ViewBase2Inner() {
  return (<>
            <ViewCopy><H>Die Berechnung mit den Basisdaten zum Haus starten.</H></ViewCopy>
            <PropertyInput placeholder_prefix="z.B." type={"postleitzahl"}/>
            <PropertyInput placeholder_prefix="z.B." type={"vollgeschosse"}/>
            <PropertyInput placeholder_prefix="z.B." type={"wohneinheiten"}/>
            <PropertyInput placeholder_prefix="z.B." type={"baujahr_base"}/>
            <PropertyInput placeholder_prefix="z.B." type={"wohnflaeche"}/>
            {/* <PropertyInput type={"privat"}/> */}
         </>)
}